import { Box } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import ReferalImage from "../../../Assets/images/referal.svg";

const ReferalContainer = styled.div`
  background-color: #ffffff;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  border-radius: 5px;
  padding: 0 45px;
  flex-direction: row;
  position: relative;
  .image {
    overflow: hidden;
    img {
      bottom: -20px;
      position: relative;
    }
  }

  .text {
    flex-grow: 1;
    font-size: 1.2rem;
    color: #5340e7;
    text-align: right;
    flex-direction: column;
    justify-content: center;
    padding: 0 30px;
    p {
      font-weight: bold;
      margin: 10px 0;
    }
  }
  .button {
    padding: 8px 15px;
    font-size: 0.8rem;
    background-color: #5340e7;
    border-radius: 10px;
    color: #ffffff;
    cursor: pointer;
  }

  @media (max-width: 992px) {
    padding: 15px 10px;
    .image {
      display: none;
    }
    .text {
      font-size: 1rem;
    }
  }
  @media (max-width: 480px) {
    flex-direction: column;
    padding: 15px 10px;
    .image {
      display: none;
    }
    .text {
      font-size: 1.1rem;
    }
    .button {
      margin: 20px 0;
    }
  }
`;

function DashboardReferal() {
  return (
    <ReferalContainer>
      <Box className="image" display="flex" alignItems="flex-end">
        <img src={ReferalImage} alt="referal" width="200" />
      </Box>
      <Box className="text" display="flex" fontWeight="bold">
        <p>دوست خود را به لینگوتاک دعوت کن،</p>
        <p>هر کدام ۳۰ هزار تومان اعتبار هدیه دریافت کنید.</p>
      </Box>
      <Box my="10px">
        <a href="/referral" className="button" display="flex">
          اطلاعات بیشتر
        </a>
      </Box>
    </ReferalContainer>
  );
}

export default DashboardReferal;
